import { render, staticRenderFns } from "./settings-navigation.vue?vue&type=template&id=688f225a"
import script from "./settings-navigation.vue?vue&type=script&lang=js"
export * from "./settings-navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('688f225a')) {
      api.createRecord('688f225a', component.options)
    } else {
      api.reload('688f225a', component.options)
    }
    module.hot.accept("./settings-navigation.vue?vue&type=template&id=688f225a", function () {
      api.rerender('688f225a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/settings/settings-navigation.vue"
export default component.exports